import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { Loader2 } from "lucide-react";

/**
 * Iter-147 — Confirmation prompt shown before re-running Build
 * Scenes & Cast on a slot that has already been built. The first
 * Build pass runs silently; only re-runs go through this dialog so
 * the user understands that re-parsing replaces the existing scene
 * draft for this episode.
 *
 * Tone: calm, declarative, no warning red. Matches the existing
 * ConfirmReplaceScriptDialog visual language.
 */
export default function ConfirmRebuildSceneCastDialog({
    open,
    onOpenChange,
    onConfirm,
    busy = false,
    episodeLabel = null,
    scenesCount = null,
    charactersCount = null,
}) {
    const titleEpisode = episodeLabel
        ? `EP ${episodeLabel}`
        : "this script";
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent
                data-testid="confirm-rebuild-dialog"
                className="sm:max-w-md"
            >
                <DialogHeader>
                    <DialogTitle data-testid="confirm-rebuild-dialog-title">
                        Rebuild Scenes &amp; Cast?
                    </DialogTitle>
                    <DialogDescription
                        data-testid="confirm-rebuild-dialog-description"
                    >
                        {titleEpisode} has already been built
                        {typeof scenesCount === "number" &&
                        typeof charactersCount === "number"
                            ? ` (${scenesCount} scenes, ${charactersCount} cast)`
                            : ""}
                        . Running Build again will replace the existing
                        scene draft for this episode with what the script
                        says now. Continuity records and the rest of the
                        project stay untouched.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="gap-2 sm:gap-0">
                    <Button
                        type="button"
                        variant="secondary"
                        data-testid="confirm-rebuild-dialog-cancel"
                        onClick={() => onOpenChange(false)}
                        disabled={busy}
                    >
                        Keep current
                    </Button>
                    <Button
                        type="button"
                        data-testid="confirm-rebuild-dialog-confirm"
                        onClick={onConfirm}
                        disabled={busy}
                        className="font-semibold"
                    >
                        {busy ? (
                            <Loader2 size={14} className="animate-spin" />
                        ) : (
                            "Rebuild"
                        )}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
